<section class="hd-nodal-environments-info">
  <div class="hd-nodal-environments-info__header">
    <h3 class="hd-nodal-environments-info__title">{{ title() }}</h3>
    @if (ownLines().length > 0 || ownEnvironments().length > 0) {
      <div class="hd-nodal-environments-info__header-actions">
        @if (ownLines().length > 0) {
          <button type="button" class="hd-nodal-environments-info__jump hd-nodal-environments-info__jump-to-own-lines"
                  (click)="scrollToOwnLines()">
            {{ jumpToOwnLinesLabel() }}
          </button>
        }
        @if (ownEnvironments().length > 0) {
          <button type="button" class="hd-nodal-environments-info__jump hd-nodal-environments-info__jump-to-own"
                  (click)="scrollToOwn()">
            {{ jumpToOwnLabel() }}
          </button>
        }
      </div>
    }
  </div>

  @if (contextLabel()) {
    <p class="hd-nodal-environments-info__context">{{ contextLabel() }}</p>
  }

  <markdown class="hd-nodal-environments-info__markdown" [src]="generalUrl()" />

  <!-- Lijnkaarten van het eigen levenskruis (design + personaliteit), bewust
       vóór "De 32 omgevingen": eerst de lijnthematiek, dan de poortthema's. -->
  @if (ownLines().length > 0) {
    <section class="hd-nodal-environments-info__lines">
      <div class="hd-nodal-environments-info__markdown hd-nodal-environments-info__markdown--continued">
        <h2>{{ ownLinesTitle() }}</h2>
        @if (ownLinesIntro()) {
          <p>{{ ownLinesIntro() }}</p>
        }
      </div>
      <div class="hd-nodal-environments-info__lines-grid">
        @for (own of ownLines(); track own.side + own.line) {
          <hd-nodal-line-card [line]="own.line" [side]="own.side" />
        }
      </div>
    </section>
  }

  <markdown class="hd-nodal-environments-info__markdown hd-nodal-environments-info__markdown--continued"
            [src]="environmentsIntroUrl()" />

  @if (ownEnvironments().length > 0) {
    <div class="hd-nodal-environments-info__own">
      <div class="hd-nodal-environments-info__own-head">
        <span class="hd-nodal-environments-info__own-label">{{ ownLabel() }}</span>
        <button type="button" class="hd-nodal-environments-info__show-all-toggle"
                [class.is-active]="showAll()"
                [attr.aria-pressed]="showAll()"
                (click)="toggleShowAll()">
          {{ toggleLabel() }}
        </button>
      </div>
      <div class="hd-nodal-environments-info__own-chips">
        @for (own of ownEnvironments(); track own.label) {
          <button type="button" class="hd-nodal-environments-info__own-chip"
                  (click)="scrollToSection(own.key)">
            <ng-container *ngTemplateOutlet="directionLabel; context: { $implicit: own.parts }" />
          </button>
        }
      </div>
    </div>
  }

  @for (section of visibleSections(); track section.key) {
    <section class="hd-nodal-environments-info__section" [attr.data-env-key]="section.key">
      <header class="hd-nodal-environments-info__section-header">
        <h4 class="hd-nodal-environments-info__section-title">{{ section.label }}</h4>
        @if (section.subtitle) {
          <span class="hd-nodal-environments-info__section-subtitle">{{ section.subtitle }}</span>
        }
        @if (section.ownBadges.length > 0) {
          <span class="hd-nodal-environments-info__own-badges">
            @for (badge of section.ownBadges; track badge.label) {
              <span class="hd-nodal-environments-info__own-badge">
                <ng-container *ngTemplateOutlet="directionLabel; context: { $implicit: badge.parts }" />
              </span>
            }
          </span>
        }
      </header>
      <markdown class="hd-nodal-environments-info__markdown" [src]="section.url" />
    </section>
  }
</section>

<!-- Richtinglabel ("Design van ☋49 naar ☊4"): elk stuk op één regel, zodat er geen
     template-witruimte tussen glyph en getal of rond de tekststukken sluipt. -->
<ng-template #directionLabel let-parts>
  @for (part of parts; track $index) {
    <span class="hd-nodal-environments-info__label-part">@if (part.glyph) {<span class="hd-nodal-environments-info__node-glyph" aria-hidden="true">{{ part.glyph }}</span>}{{ part.text }}</span>
  }
</ng-template>
